// removed by extract-text-webpack-plugin
module.exports = {"container":"_1vNBsCgpM3wx5XxZkmbI5V","visible":"yVU3pTieh8XuDzPHa_f5c"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6136fd75","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/rep-call/recording-indicator/recording-indicator.less
// module id = mUgx
// module chunks = 1